import React from "react";
import PropTypes from "prop-types";

import AddEditAccountFields from "./AddEditAccountFields";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import useFormValidator from "hooks/useFormValidator";

import { addAccountExtendValidator } from "validators/addAccountExtendValidator";
import { ADD_ACCOUNT, GET_ACCOUNTS_NAME } from "graphqlQueries/accounts";

const initialValues = {
  name: "",
  description: "",
  pmn_amount: 1,
  ipmp_user: "",
  password: "",
  confirm_password: "",
  enabled: true,
};

const fieldsWithPlaceForError = [
  "name",
  "description",
  "pmn_amount",
  "ipmp_user",
  "password",
];

const AddAccountDialog = (props) => {
  const { validationSchema } = useFormValidator(
    "create_ipmp",
    {
      name: "System name",
      pmn_amount: "Max. instances",
      ipmp_user: "Username",
      password: "Password",
    },
    addAccountExtendValidator,
  );

  return (
    <DialogFormWithMutation
      mutationQueries={ADD_ACCOUNT}
      refetchQueries={[GET_ACCOUNTS_NAME]}
      initialValues={initialValues}
      validationSchema={validationSchema}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New account"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <AddEditAccountFields />
    </DialogFormWithMutation>
  );
};

AddAccountDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddAccountDialog;
